// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qGOai","name":"Header_name__3T3cy","birthday":"Header_birthday__3nQFq","skeleton":"Header_skeleton__1s3RP"};